import { LoadingStatus } from "@/features/loading/stores/useLoadingStore";

export type ResourceMap = Map<
  string,
  { url: string; status: LoadingStatus; error?: string }
>;

export type LoadResult = {
  status: LoadingStatus;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
};

export function load(resources: ResourceMap, criticalKeys: string[]): LoadResult {
  const statuses = criticalKeys.map((key) => resources.get(key)?.status);

  const anyLoading = statuses.some((s) => s === LoadingStatus.LOADING);
  const anyError = statuses.some((s) => s === LoadingStatus.ERROR);
  const allLoaded = statuses.every((s) => s === LoadingStatus.LOADED);
  const anyMissing = criticalKeys.some((key) => !resources.has(key));

  const status = anyError ? LoadingStatus.ERROR : (anyLoading || anyMissing) ? LoadingStatus.LOADING : LoadingStatus.LOADED;

  return {
    status: status,
    isLoading: anyLoading || anyMissing,
    isError: anyError,
    isSuccess: allLoaded && !anyMissing,
  };
}
